import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import ModalHeader from '../../components/ModalHeader';
import AbstractModalView from '../AbstractModalView';
import types from '../../types'
import styles from './styles.module.scss';

const ButtonShowModal = ({label, children, headerContent}) => (
  <>
    <AbstractModalView
      subPath={'info'}
      triggerContent={({openModal}) => (
        <Button
          type='button'
          variant='secondary'
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            openModal()
          }}
          label={label}
        />
      )}
      modalContent={({closeModal}) => (
        <>
          <div className={styles.modalHeaderContainer}>
            <ModalHeader onClick={closeModal}>{headerContent}</ModalHeader>
          </div>
          <div className={styles.modalContentContainer}>
            {children({closeModal})}
          </div>
        </>
      )}
    />
  </>
);

ButtonShowModal.propTypes = {
  ...types.children,
  label: PropTypes.node,
  headerContent: PropTypes.node,
};

export default ButtonShowModal;
